// 部门公告
export const getDepartmentBulletin = (params) => {
  return window._this.$http.get(
    `/erp/PurchaseWorkbench/purchaseDepartmentNotice`,
    {
      params,
    }
  );
};

// 迭代公告
export const getIterationBulletin = (params) => {
  return window._this.$http.get(
    `/erp/PurchaseWorkbench/purchaseIterationNotice`,
    {
      params,
    }
  );
};

// 代采单欠货信息
export const getPurchaseOweInfo = (params) => {
  return window._this.$http.get(`/erp/PurchaseWorkbench/purchaseOwe`, {
    params,
  });
};

// 包裹信息
export const getPackageInfo = (params) => {
  return window._this.$http.get(`/erp/PurchaseWorkbench/packageInfo`, {
    params,
  });
};

// 获取城市和数据维度
export const getPurchaseSearchCondition = (params) => {
  return window._this.$http.get(
    `/erp/PurchaseWorkbench/purchaseSearchCondition`,
    {
      params,
    }
  );
};

// 获取已入库未付款订单
export const getWarehouseUnpaid = (params) => {
  return window._this.$http.get(`/erp/PurchaseWorkbench/warehousedUnpaid`, {
    params,
  });
};

// 获取无数据待处理
export const getNoDataGoods = (params) => {
  return window._this.$http.get(`/erp/PurchaseWorkbench/waitNoDataGoods`, {
    params,
  });
};

// 获取根据城市和数据维度获取选项
export const getOptionsByCityAndType = (params) => {
  return window._this.$http.get(`/erp/PurchaseWorkbench/getPgSelectData`, {
    params,
  });
};

// 开单信息
export const getBillingInfo = (params) => {
  return window._this.$http.get(`/erp/PurchaseWorkbench/wcgOrderInformation`, {
    params,
  });
};

// 触达信息
export const getReachInfo = (params) => {
  return window._this.$http.get(`/erp/PurchaseWorkbench/reachInformation`, {
    params,
  });
};



// WEBPACK FOOTER //
// ./src/api/purchaseDashboard.js